"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SceneActionButtons = exports.DeviceRoleType = exports.IndexAPIThingType = exports.IndexAPIScheduleDays = exports.ScheduleFrameEvent = exports.ScheduleFrameType = exports.IndexAPIActuatorCapabilities = exports.IndexAPIDeviceType = void 0;
var IndexAPIDeviceType;
(function (IndexAPIDeviceType) {
    IndexAPIDeviceType["ZONE"] = "zone";
    IndexAPIDeviceType["SCENE"] = "scene";
    IndexAPIDeviceType["LOAD"] = "load";
    IndexAPIDeviceType["PLUG"] = "plug";
    IndexAPIDeviceType["SWITCH"] = "switch";
    IndexAPIDeviceType["GEN1LOAD"] = "gen1_load";
    IndexAPIDeviceType["BRIDGE"] = "bridge";
})(IndexAPIDeviceType = exports.IndexAPIDeviceType || (exports.IndexAPIDeviceType = {}));
var IndexAPIActuatorCapabilities;
(function (IndexAPIActuatorCapabilities) {
    IndexAPIActuatorCapabilities["POWER"] = "power";
    IndexAPIActuatorCapabilities["DIM_POWER"] = "dim+power";
    IndexAPIActuatorCapabilities["EXECUTE"] = "execute";
})(IndexAPIActuatorCapabilities = exports.IndexAPIActuatorCapabilities || (exports.IndexAPIActuatorCapabilities = {}));
var ScheduleFrameType;
(function (ScheduleFrameType) {
    ScheduleFrameType["TIME"] = "time";
    ScheduleFrameType["EVENT"] = "event";
})(ScheduleFrameType = exports.ScheduleFrameType || (exports.ScheduleFrameType = {}));
var ScheduleFrameEvent;
(function (ScheduleFrameEvent) {
    ScheduleFrameEvent["SUNSET"] = "sunset";
    ScheduleFrameEvent["SUNRISE"] = "sunrise";
})(ScheduleFrameEvent = exports.ScheduleFrameEvent || (exports.ScheduleFrameEvent = {}));
var IndexAPIScheduleDays;
(function (IndexAPIScheduleDays) {
    IndexAPIScheduleDays["MON"] = "Mon";
    IndexAPIScheduleDays["TUE"] = "Tue";
    IndexAPIScheduleDays["WED"] = "Wed";
    IndexAPIScheduleDays["THU"] = "Thu";
    IndexAPIScheduleDays["FRI"] = "Fri";
    IndexAPIScheduleDays["SAT"] = "Sat";
    IndexAPIScheduleDays["SUN"] = "Sun";
})(IndexAPIScheduleDays = exports.IndexAPIScheduleDays || (exports.IndexAPIScheduleDays = {}));
var IndexAPIThingType;
(function (IndexAPIThingType) {
    IndexAPIThingType["V1"] = "thing-v1";
    IndexAPIThingType["V2"] = "thing-v2";
})(IndexAPIThingType = exports.IndexAPIThingType || (exports.IndexAPIThingType = {}));
var DeviceRoleType;
(function (DeviceRoleType) {
    DeviceRoleType["RELAY"] = "relay";
    DeviceRoleType["MATTER"] = "matter";
})(DeviceRoleType = exports.DeviceRoleType || (exports.DeviceRoleType = {}));
var SceneActionButtons;
(function (SceneActionButtons) {
    SceneActionButtons["BUTTON_ONE"] = "button1";
    SceneActionButtons["BUTTON_TWO"] = "button2";
    SceneActionButtons["BUTTON_THREE"] = "button3";
})(SceneActionButtons = exports.SceneActionButtons || (exports.SceneActionButtons = {}));
//# sourceMappingURL=IndexApiProfileRequestTypes.js.map